import { VERSION, STATUS } from '../constants';
import { resolve } from '../api';

export const initialVersionState = {
  status: STATUS.IDLE,
  error: null,
  // version: '0.0.1-initial',
};

export default (state = initialVersionState, action) => {
  switch (action?.type) {
    case VERSION:
      return {
        ...state,
        status: STATUS.LOADING,
      };
    case resolve(VERSION):
      return {
        ...state,
        version: action?.payload,
        status: STATUS.LOADED,
      };
    default:
      return state;
  }
};
